import { Delete } from '@mui/icons-material';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import { deleteExpert } from '../../../api/products';

export default function DeleteExpertAdvice({ data, fetchData, token }) {
  const [error, setError] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDelete = useCallback(async () => {
    const response = await deleteExpert(data.id, token);
    if (response.ok) {
      fetchData();
    } else {
      setError('Failed to delete expert. Please try again.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, fetchData]);

  const handleDeleteButtonClick = () => {
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirm = () => {
    handleDelete();
    setDeleteConfirmationOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
  };

  return (
    <>
      <IconButton
        variant="text"
        color="error"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleDeleteButtonClick}>
        <Delete /> Delete
      </IconButton>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleDeleteCancel}
        fullWidth
        maxWidth="xs">
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to delete <strong>{data.name}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
